import { InternalCostModalPartial } from "../../../../partials/admin/menus/proposals/internal-cost-modal.admin.partial";

export const InternalCostModalScreen: React.FunctionComponent = () => {
  return <InternalCostModalPartial />;
};
